import { render, staticRenderFns } from "./categoryNews.vue?vue&type=template&id=006d4bde&scoped=true&"
import script from "./categoryNews.vue?vue&type=script&lang=js&"
export * from "./categoryNews.vue?vue&type=script&lang=js&"
import style0 from "./categoryNews.vue?vue&type=style&index=0&id=006d4bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d4bde",
  null
  
)

export default component.exports